module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_4.948250bb.jpg";